// v2.1.0 – Modern 2026 UX/UI (WHITE + Professional)

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ShippingAddress = () => {
  const { shippingAddress, updateShippingAddress } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    address: '',
    city: '',
    postcode: '',
    country: ''
  });

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (shippingAddress) setFormData(shippingAddress);
  }, [shippingAddress]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await updateShippingAddress(formData);

    setMessage(result.message);
    setLoading(false);

    if (result.success) {
      setTimeout(() => navigate('/order-summary'), 1200);
    } else {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* HEADER */}
        <div style={styles.header}>
          <h2 style={styles.title}>Shipping Address</h2>
          <p style={styles.subtitle}>
            Enter your delivery details securely
          </p>
        </div>

        {/* MESSAGE */}
        {message && (
          <div style={styles.success}>
            {message}
          </div>
        )}

        {/* FORM */}
        <form onSubmit={handleSubmit} style={styles.form}>

          <Input label="Street Address" name="address" value={formData.address} onChange={handleChange} />
          <Input label="City" name="city" value={formData.city} onChange={handleChange} />

          <div style={styles.row}>
            <Input label="Postcode" name="postcode" value={formData.postcode} onChange={handleChange} />
            <Input label="Country" name="country" value={formData.country} onChange={handleChange} />
          </div>

          <button
            type="submit"
            style={loading ? styles.buttonLoading : styles.button}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save & Continue'}
          </button>

        </form>
      </div>
    </div>
  );
};

export default ShippingAddress;

/* ================= COMPONENT ================= */

const Input = ({ label, name, value, onChange }) => (
  <div style={styles.inputGroup}>
    <label style={styles.label}>{label}</label>
    <input
      name={name}
      value={value}
      onChange={onChange}
      required
      style={styles.input}
      onFocus={(e) => {
        e.target.style.border = '1px solid #4f8cff';
        e.target.style.boxShadow = '0 0 0 3px rgba(79,140,255,0.15)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid #ddd';
        e.target.style.boxShadow = 'none';
      }}
    />
  </div>
);

/* ================= STYLES ================= */

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    background: '#ffffff', // ✅ WHITE BACKGROUND
  },

  card: {
    width: '100%',
    maxWidth: '520px',
    padding: '30px',
    borderRadius: '16px',
    background: '#ffffff',
    border: '1px solid #eee',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)', // subtle professional shadow
  },

  header: {
    marginBottom: '20px',
    textAlign: 'center',
  },

  title: {
    color: '#111',
    fontWeight: '700',
    marginBottom: '5px',
  },

  subtitle: {
    color: '#666',
    fontSize: '14px',
  },

  success: {
    background: '#f0f6ff',
    border: '1px solid #4f8cff',
    padding: '10px',
    borderRadius: '8px',
    color: '#2c5cff',
    textAlign: 'center',
    marginBottom: '15px',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },

  row: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },

  inputGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },

  label: {
    color: '#333',
    fontSize: '13px',
    marginBottom: '5px',
    fontWeight: '500',
  },

  input: {
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #ddd',
    background: '#fff',
    color: '#111',
    outline: 'none',
    transition: '0.2s',
  },

  button: {
    marginTop: '10px',
    padding: '12px',
    borderRadius: '999px',
    border: 'none',
    background: '#4f8cff',
    color: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(79,140,255,0.3)',
  },

  buttonLoading: {
    marginTop: '10px',
    padding: '12px',
    borderRadius: '999px',
    border: 'none',
    background: '#9bbcff',
    color: '#fff',
    fontWeight: '600',
    cursor: 'not-allowed',
  },
};